import React from 'react';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import POS from '../../Components/Admin/POS/POS';

export default function POSPage() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <POS />
                </div>
            </section>
        </div>
    );
}
